import { useState } from 'react';
import SEO from '../components/SEO';
import API_BASE_URL from '../config';

function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  var handleChange = function (e) { setForm(Object.assign({}, form, { [e.target.name]: e.target.value })); };
  var handleSubmit = async function (e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Something went wrong');
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-contact">
      <SEO title="Contact Us" description="Get in touch with the Anthroper team. Send us feedback, feature requests, or report bugs." path="/contact" />
      <div className="container content-page">
        <h1>Contact Us</h1>
        <p>We value your feedback and are always looking for ways to improve. Whether you have a feature request, found a bug, or just want to say hello, we would love to hear from you.</p>
        {submitted ? (
          <div className="success-message" role="status">
            {"\u2705"} Thank you for reaching out! We will get back to you as soon as possible.
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            {error && <div className="error-message" role="alert">{error}</div>}
            <div className="form-group">
              <label htmlFor="contact-name">Name</label>
              <input id="contact-name" type="text" name="name" value={form.name} onChange={handleChange} required placeholder="Your name" maxLength={200} />
            </div>
            <div className="form-group">
              <label htmlFor="contact-email">Email</label>
              <input id="contact-email" type="email" name="email" value={form.email} onChange={handleChange} required placeholder="your@email.com" maxLength={320} />
            </div>
            <div className="form-group">
              <label htmlFor="contact-message">Message</label>
              <textarea id="contact-message" name="message" value={form.message} onChange={handleChange} required rows={6} placeholder="Tell us what is on your mind..." maxLength={5000} />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
        <section className="contact-info">
          <h2>Other Ways to Reach Us</h2>
          <p>Email: <a href="mailto:akshay.personal.business@gmail.com">akshay.personal.business@gmail.com</a></p>
          <p>We typically respond within 24 to 48 hours on business days.</p>
        </section>
      </div>
    </div>
  );
}

export default Contact;
